<template>
	<app-section :class="$attrs.class">
		<div class="flex items-center">
			<app-title title="Restaurant" class="flex flex-1" />
			<!--			<app-button class="btn btn-transparent transparent" icon="pencil" />-->
		</div>
		<app-line />

		<div>{{ restaurant?.restaurantID !== 0 ? restaurant['restaurantName'] : 'All Businesses' }}</div>
		<app-line />
		<div v-if="restaurant && restaurant.posNumber">Contact: {{ restaurant.posNumber }}</div>
	</app-section>
</template>

<script>
	import AppTitle from '@/components/app/AppTitle';

	export default {
		name: 'RestaurantDetails',
		components: {
			AppTitle,
		},
		props: {
			restaurant: {
				required: true,
				type: Object,
			},
		},
	};
</script>
